package com.vizio.redwolf.utils

import kotlin.js.JsExport

@JsExport
interface ConsentV2ProxyEnvironment : Environment {
    val host: String
    val envPath: String
    val apiVersion: String
}

@JsExport
abstract class BaseConsentV2ProxyEnvironment(override val apiVersion: String = "v2") : ConsentV2ProxyEnvironment

@JsExport
data class DevConsentV2ProxyEnvironment(
    override val host: String = "dev.redwolf.external.plat.vizio.com",
    override val envPath: String = "consent-management"
) : BaseConsentV2ProxyEnvironment()

@JsExport
data class StageConsentV2ProxyEnvironment(
    override val host: String = "stage.redwolf.external.plat.vizio.com",
    override val envPath: String = "consent-management"
) : BaseConsentV2ProxyEnvironment()

@JsExport
data class PreProdConsentV2ProxyEnvironment(
    override val host: String = "preprod.redwolf.external.plat.vizio.com",
    override val envPath: String = "consent-management"
) : BaseConsentV2ProxyEnvironment()

@JsExport
data class ProdConsentV2ProxyEnvironment(
    override val host: String = "prod.redwolf.external.plat.vizio.com",
    override val envPath: String = "consent-management"
) : BaseConsentV2ProxyEnvironment()

fun chooseConsentV2ProxyEnvironment(envConfig: ConsentV2ProxyEnvironmentConfig): ConsentV2ProxyEnvironment {
    return when (envConfig.environmentGroup) {
        EnvironmentGroup.PROD -> ProdConsentV2ProxyEnvironment()
        EnvironmentGroup.PREPROD -> PreProdConsentV2ProxyEnvironment()
        EnvironmentGroup.STAGE -> StageConsentV2ProxyEnvironment()
        EnvironmentGroup.DEV -> DevConsentV2ProxyEnvironment()
        EnvironmentGroup.TEST -> TODO("Test Environment for Consent not defined yet!")
    }
}